<template>

    <Toast />

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Account</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Account Management</a></li>
                    </ul>

                    <h3>Overview</h3>

                    <div class="field">
                        <label for="companyId">Company ID</label>
                        <InputText id="companyId" type="text" :disabled="true" v-model.trim="profile.companyId" />
                    </div>

                    <div class="field">
                        <label for="id">User ID</label>
                        <InputText id="id" type="text" :disabled="true" v-model.trim="profile.id" />
                    </div>

                    <div class="field">
                        <label for="username">Username</label>
                        <InputText id="username" :disabled="true" v-model.trim="profile.username" required="true" />
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="email" :disabled="false" v-model.trim="profile.email" required="true" />
                    </div>

                    <div class="field">
                        <label for="mobile">Mobile</label>
                        <InputText id="mobile" :disabled="false" v-model.trim="profile.mobile" required="true" />
                    </div>

                    <div class="field">
                        <label for="firstName">First Name</label>
                        <InputText id="firstName" :disabled="false" v-model.trim="profile.firstName" required="true" />
                    </div>

                    <div class="field">
                        <label for="lastName">Last Name</label>
                        <InputText id="lastName" :disabled="false" v-model.trim="profile.lastName" required="true" />
                    </div>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted" @click="processUpdateUser"></Button>

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter />

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            submitted: false
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;
        },
        async processUpdateUser() {
            this.submitted = true;

            try {
                var newUserDto = {
                    id: this.userStore.user.id,
                    username: this.profile.username,
                    email: this.profile.email,
                    mobile: this.profile.mobile,
                    firstName: this.profile.firstName,
                    lastName: this.profile.lastName,
                    roles: this.profile.roles,
                };

                const response = await UserService.updateUser(this.userStore.user.id, newUserDto);
                console.log('[PhoneCalls][updatePhoneCall] Response = ', response);

                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Updated user details',
                    life: 3000
                });
            } catch (error) {
                console.error('[PhoneCalls][updatePhoneCall] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update user details. Please try again.',
                    life: 3000
                });
            }

            this.submitted = false;
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}

.assistant-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.assistant-badge {
    &.status-N {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-D {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-H {
        background: #ECCFFF;
        color: #694382;
    }

}
</style>
